import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './DirectDebit.scss'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import updateBankInfoServices from 'services/updateBankInfoServices'
import getApplicationServices from 'services/getApplicationServices'
import documentServices from 'services/documentServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { UpdateBankInfoEs } from '../UpdateBankInfo/UpdateBankInfoEs'
import { Decision } from 'constants/enums/decision'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'
import creditDecisionServices from 'services/creditDecisionServices'
import { cdaApiRoutes } from 'constants/routes/cdaApiRoutes'

const DirectDebitEs = () => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<Error | any>()
	const [disabled, setDisabled] = useState<boolean>(true)
	const applicationId = loanApplication.applicationData?.loanNumber!

	useEffect(() => {
		getApplicationInformation(applicationId)
	}, []) //eslint-disable-line

	const updateBankInfo = async () => {
		setLoading(true)
		setError(null)
		try {
			await updateBankInfoServices
				.updateBankInfo({
					applicationId: applicationId,
					bankInfo: loanApplication.updateApplicationData?.bankInfo!,
				})
				.then(async (response) => {
					if (response === 200) {
						runCreditDecision()
					} else {
					}
				})
		} catch (error) {
			console.warn(error)
			setError(error)
			setLoading(false)
		}
	}

	const runCreditDecision = async () => {
		setLoading(true)
		try {
			let response = await creditDecisionServices.runcreditdecision(
				applicationId!.toString(),
				cdaApiRoutes.runcreditcardcreditdecision
			)
			if (response?.status === 200) {
				dispatchLoanApplication({
					type: LOAN_APPLICATION_ACTIONS.SET_LOANOFFERDATA,
					payload: {
						...loanApplication,
						loanOfferData: response.data,
					},
				})
				await fetchApplicationAndDocumentData(applicationId!)
				dispatchMsp({
					type: MSP_ACTIONS.SET_INDEX,
					payload: {
						...msp,
						index: 0,
					},
				})
			}
		} catch (error) {
			console.warn(error)
			setError(true)
			setLoading(false)
		}
	}

	const fetchApplicationAndDocumentData = async (applicationId: number) => {
		setLoading(true)
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
			await documentServices
				.getDownloadDocuments(applicationId.toString(), t)
				.then((response) => {
					loanApplication.setDocumentData(response)
				})
		} catch (error) {
			console.warn(error)
			setError(true)
		} finally {
			setLoading(false)
		}
	}

	const getApplicationInformation = async (applicationId: number) => {
		setLoading(true)
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
			await documentServices
				.getDownloadDocuments(applicationId.toString(), t)
				.then((response) => {
					loanApplication.setDocumentData(response)
				})
		} catch (error) {
			console.warn(error)
			setError(error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (
			loanApplication.updateApplicationData?.bankInfo?.iban !==
				undefined &&
			loanApplication.updateApplicationData?.bankInfo?.iban !== ''
		) {
			setDisabled(false)
		} else {
			setDisabled(true)
		}
	}, [loanApplication.updateApplicationData?.bankInfo?.iban])

	return (
		<div className="direct-debit">
			{loading ? (
				<div className="col-spinner">
					<CircleSpinner />
				</div>
			) : (
				<>
					{loanApplication.applicationData?.decision ===
					Decision.Approved ? (
						<UpdateBankInfoEs />
					) : null}
					{error ? <ErrorBox message={t('ErrorMsg')} /> : null}
					<div className="direct-debit-next-button">
						<button
							className="btn btn-primary"
							disabled={disabled}
							onClick={() => {
								setTimeout(() => {
									updateBankInfo()
								}, 400)
							}}>
							{t('Next')}
						</button>
					</div>
				</>
			)}
		</div>
	)
}

export default DirectDebitEs
